//depending on quantity of sims, loop through array, if number is between min and max, get the amount deducted
const CIRCLES3_CHATTER_ID = '06c0b85c-0917-4ae5-b409-e46f46f7758a'
const MINI_ID = '294aa12b-916c-439b-838e-751526872e0a'

import { IBundlePlans } from '../types/api/v1/bundle.type'
interface IMoq {
  min: string
  max: string
  amt: string
}

// pricing of each bundle baseplan depending on whether discount is applied
export const calculateOriginalBeforeDiscount = (
  finalPrice: number,
  bundlePlan: IBundlePlans,
  discount: number
) => {
  if (
    bundlePlan.bundleId === CIRCLES3_CHATTER_ID ||
    bundlePlan.bundleId === MINI_ID
  ) {
    return finalPrice
  }
  //add discount10
  const finalPriceAfterDiscount = finalPrice + 10 - discount

  return finalPriceAfterDiscount
}

//total price * simsquantity is before moq discount and discount10(promocode discount)- default pricing
export const calculateTotalOriginal = (
  simsQuantity: number | string | number[],
  originalPrice: number | string
): number => {
  const previousOriginal = Number(originalPrice) + 10

  return Number(simsQuantity) * previousOriginal
}

//discount if moq is hit, price per sim, in negative value
export const getDiscountPerSim = (
  moqList: IMoq[],
  simQuantity: number
): number => {
  if (simQuantity < 2) {
    return 0
  } else {
    const expectedMoqRange = moqList.filter(
      (moq) => simQuantity > Number(moq.min) && simQuantity <= Number(moq.max)
    )
    return expectedMoqRange.length === 1 ? Number(expectedMoqRange[0].amt) : 0
  }
}

//total price after moq discount
export const calculateTotalAmtAfterMoqDiscount = (
  originalCost: number,
  simsQuantity: number,
  moqDiscount: number
): number => {
  const finalPriceCalculated = (originalCost + moqDiscount) * simsQuantity
  return finalPriceCalculated
}

//number of sims * (original amount - disocunt/sim - voucheramt)

export const calculateAmountAfterVoucher = (
  discountPerSim: number,
  voucherAmt: number,
  simsQuantity: number,
  originalAmount: number
): number => {
  const amountAfterDiscount = originalAmount + discountPerSim
  const amountAfterVoucher = amountAfterDiscount - voucherAmt

  return simsQuantity * (amountAfterVoucher < 0 ? 0 : amountAfterVoucher)
}
